import {
  EllipsisOne,
  EllipsisThree,
  EllipsisTwo
} from './LoadingEllipsis.styles';

const LoadingEllipsis = () => {
  return (
    <>
      <EllipsisOne>.</EllipsisOne>
      <EllipsisTwo>.</EllipsisTwo>
      <EllipsisThree>.</EllipsisThree>
    </>
  );
};

export default LoadingEllipsis;
